import Cookies from 'js-cookie'

import config from '@/config'
import type { DependenciasSrcNext } from '@next/app'

type EstadoAutenticacaoLegado = Readonly<{
  authorization?: string | null
  accessToken?: string | null
  userPoolId?: string | null
  userPoolWebClientId?: string | null
}>

type EstadoLegado = Readonly<{
  auth: EstadoAutenticacaoLegado
  perfilDeAcessoSelecionadoParaMultiPerfis?: string | null
}>

type StoreLegada = Readonly<{
  state: EstadoLegado
  getters: Readonly<{
    usuarioEstaAutenticado: boolean
  }>
}>

type EntradaCriarDependenciasSrcNext = Readonly<{
  store: StoreLegada
}>

const obterPrimeiroValorPreenchido = (
  ...valores: Array<string | null | undefined>
): string | undefined => {
  for (const valor of valores) {
    if (typeof valor === 'string' && valor.trim().length > 0) return valor
  }

  return undefined
}

export const criarDependenciasSrcNext = ({
  store,
}: EntradaCriarDependenciasSrcNext): DependenciasSrcNext => ({
  servicosHttp: {
    condominio: {
      urlBase: `${config.baseUrl}/api`,
      urlFallback: `${config.baseUrl}/api`,

      obterCredenciais: () => {
        const authorization = obterPrimeiroValorPreenchido(
          store.state.auth.authorization,
          Cookies.get('Authorization'),
        )
        const accessToken = obterPrimeiroValorPreenchido(
          store.state.auth.accessToken,
          Cookies.get('accessToken'),
        )
        const userPoolId = obterPrimeiroValorPreenchido(
          store.state.auth.userPoolId,
          Cookies.get('userPoolId'),
        )
        const userPoolWebClientId = obterPrimeiroValorPreenchido(
          store.state.auth.userPoolWebClientId,
          Cookies.get('userPoolWebClientId'),
        )

        return {
          ...(authorization ? { authorization } : {}),
          ...(accessToken ? { accessToken } : {}),
          ...(userPoolId ? { userPoolId } : {}),
          ...(userPoolWebClientId ? { userPoolWebClientId } : {}),
        }
      },

      obterPerfilAcesso: () => (
        store.getters.usuarioEstaAutenticado
          ? store.state.perfilDeAcessoSelecionadoParaMultiPerfis
          : null
      ),

      obterIdioma: () => localStorage.getItem('idioma'),
    },
  },
})
